/**
 * APPLE-STYLE ENGINE V2.0 - ZERO FOUC & JUMP FIX
 */

class AppleNav {
  constructor() {
    this.config = { mountId: 'sys-nav-mount', hostId: 'sys-nav-host' };
    
    const c = window.SysNavConfig || {};
    this.logoUrl = c.logo || "";
    this.logoHeight = c.logoHeight || 21;
    this.shopName = c.shopName || "Shop";
    this.showSearch = c.showSearch !== false;
    this.showAccount = c.showAccount === true;
    this.accountUrl = c.accountUrl || "/account";
    this.rootUrl = c.rootUrl || "/";
    this.searchUrl = c.searchUrl || "/search";
    this.quickLinks = c.quickLinks || [];
    this.cartMenu = c.cartMenu || [];
    this.menuSettings = c.menuSettings || {};
    this.isCustomer = c.isCustomer || false;
    this.routes = c.routes || {};
    // Feature Flag for Drawer
    this.enableCartDrawer = c.enableCartDrawer !== false; 

    this.state = {
      isOpen: false,
      cartOpen: false,
      searchOpen: false,    
      cartData: null,     
      lastScrollY: 0,
      ticking: false,
      currentItems: [],
      history: [], 
      touchStartX: 0,
      touchStartY: 0
    };

    this.cartPollInterval = null;
    this.boundHandlers = {};

    this.init = this.init.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.update = this.update.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleCart = this.toggleCart.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.monitorCart = this.monitorCart.bind(this);
    this.preloadCart = this.preloadCart.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.closeAll = this.closeAll.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.lockScroll = this.lockScroll.bind(this);
    this.unlockScroll = this.unlockScroll.bind(this);
  }

  init() {
    this.mount = document.getElementById(this.config.mountId);
    this.host = document.getElementById(this.config.hostId);
    
    if (!this.mount || !this.host) return;

    this.destroy();

    if (window.SysNavData && window.SysNavData.root) {
      this.state.currentItems = window.SysNavData.root;
      this.renderSystem(); 
    } else {
      setTimeout(() => {
        if (window.SysNavData && window.SysNavData.root) {
          this.state.currentItems = window.SysNavData.root;
          this.renderSystem();
        }
      }, 50);
    }

    this.state.lastScrollY = window.scrollY;
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    this.preloadCart();
    this.startCartMonitoring();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);

    // DS Cart V2: React to add-to-cart events, badge + auto-open + re-render
    document.addEventListener('ajaxProduct:added', () => {
      // Abort previous event-triggered fetch to prevent stale responses from reopening cart
      if (this._eventFetchCtrl) this._eventFetchCtrl.abort();
      this._eventFetchCtrl = new AbortController();
      fetch('/cart.js', { signal: this._eventFetchCtrl.signal })
        .then(r => r.json())
        .then(c => {
          this.state.cartData = c;
          this.updateBadge(c.item_count);
          this.preloadCartImages(c);
          // safe: renderCartHTML uses only cart data from /cart.js (Shopify API)
          const area = document.getElementById('sn-cart-content-area');
          if (this.state.cartOpen && area) {
            area.innerHTML = this.renderCartHTML(c);
            document.dispatchEvent(new CustomEvent('cart:rendered'));
          }
          if (!this.state.cartOpen) {
            this.toggleCart();
          }
        })
        .catch(e => { if (e.name !== 'AbortError') console.error('Cart refresh error:', e); });
    });

  }

  renderSystem() {
    const iconSearch = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.0" stroke-linecap="round"><circle cx="8" cy="8" r="6.5"></circle><line x1="12.8" y1="12.8" x2="16.5" y2="16.5"></line></svg>`;
    const iconAccount = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.0" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>`;
    const iconBag = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.0"><path d="M6 8h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2z"></path><path d="M8 8V6a4 4 0 0 1 8 0v2" stroke-linecap="round"></path></svg>`;
    const iconBack = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>`;
    
    const cartCount = window.SysNavData.cartCount || 0;
    const badgeHTML = cartCount > 0 ? `<span class="sn-cart-badge">${cartCount}</span>` : '';

    let actionsHtml = '';
    if (this.showSearch) actionsHtml += `<button class="sn-icon-btn" id="sn-search-btn" aria-label="Suche" type="button">${iconSearch}</button>`;
    
    if (this.showAccount) {
        // FIX: Verlinktes Icon
        const accTarget = this.isCustomer ? this.routes.account : this.routes.login;
        actionsHtml += `<a href="${accTarget}" class="sn-icon-btn" aria-label="Account">${iconAccount}</a>`;
    }
    
    actionsHtml += `<button class="sn-icon-btn" id="sn-cart-btn" aria-label="Warenkorb">${iconBag}${badgeHTML}</button>`;
    actionsHtml += `<div style="width: 26px;" class="mobile-spacer"></div>`;

    let logoHtml = `<span style="font-weight:600; font-size:18px; color:var(--sn-color-main);">${this.shopName}</span>`;
    if (this.logoUrl) {
        logoHtml = `<img src="${this.logoUrl}" class="sn-logo-img" style="height:${this.logoHeight}px; width:auto;" alt="${this.shopName}" loading="eager">`;
    }

    this.mount.innerHTML = `
      <header class="sys-nav-bar">
        <div class="sn-bar-inner">
          <a href="${this.rootUrl}" class="sn-logo-link" id="sn-logo">${logoHtml}</a>
          <nav class="sn-desktop-nav">${this.getDesktopHTML()}</nav>
          <div class="sn-actions">${actionsHtml}</div>
        </div>
        <div class="sn-cart-pane" id="sn-cart-pane"><div class="sn-mega-inner" id="sn-cart-content-area"></div></div>
        <div class="sn-search-pane" id="sn-search-pane">
          <div class="sn-search-inner">
            <form action="/search" method="get" class="sn-search-form" id="sn-search-form">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.0" stroke-linecap="round" aria-hidden="true"><circle cx="8" cy="8" r="6.5"></circle><line x1="12.8" y1="12.8" x2="16.5" y2="16.5"></line></svg>
              <input type="text" name="q" placeholder="dogssupreme.de durchsuchen" class="sn-search-input" id="sn-search-input" autocomplete="off">
              <button type="button" class="sn-search-clear" id="sn-search-clear" aria-label="Suche leeren">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="8" fill="#86868b"/><path d="M5 5L11 11M11 5L5 11" stroke="#fff" stroke-width="1.4" stroke-linecap="round"/></svg>
              </button>
            </form>
            <div class="sn-search-quicklinks" id="sn-search-quicklinks">
              <div class="sn-search-quicklinks-label">QUICK LINKS</div>
              <div class="sn-search-quicklinks-grid">${this.getSearchQuicklinksHTML()}</div>
            </div>
            <div class="sn-search-results" id="sn-search-results" hidden></div>
          </div>
        </div>
      </header>
      <div class="sn-mega-shell" id="sn-mega-shell">${this.getMegaPanesHTML()}</div>
      <button class="sn-global-burger" id="sn-trigger" aria-label="Menü"><div class="sn-burger-inner"><span class="sn-line top"></span><span class="sn-line bot"></span></div></button>
      <div class="sn-overlay" id="sn-overlay"><div class="sn-overlay-header"><button class="sn-nav-btn hidden" id="sn-back-btn" aria-label="Zurück">${iconBack}</button></div><div class="sn-viewport"><div class="sn-list-wrapper" id="sn-list-wrapper"></div></div></div>
      <div class="sn-desktop-backdrop" id="sn-backdrop"></div>
    `;

    this.attachListeners();
    this.initDesktopHover();
  }

  getDesktopHTML() {
    let html = '';
    if (!this.state.currentItems) return html;
    this.state.currentItems.forEach((item, idx) => {
      if (!item.hasChildren) {
        html += `<div class="sn-desktop-item"><a href="${item.url}" class="sn-desktop-link">${item.title}</a></div>`;
      } else {
        html += `<div class="sn-desktop-item has-mega" data-mega="mega-${idx}"><a href="${item.url}" class="sn-desktop-link">${item.title}</a></div>`;
      }
    });
    return html;
  }

  getMegaPanesHTML() {
    let html = '';
    if (!this.state.currentItems) return html;
    this.state.currentItems.forEach((item, idx) => {
      if (!item.hasChildren) return;
      let inner = '';
      const hasGrandchildren = item.children.some(c => c.hasChildren && c.children && c.children.length > 0);
      if (!hasGrandchildren) {
        inner += `<div class="sn-mega-col"><span class="sn-mega-title">${item.title} entdecken</span>`;
        item.children.forEach(child => {
          inner += `<a href="${child.url}" class="sn-mega-product-link">${child.title}</a>`;
        });
        inner += `</div>`;
      } else {
        item.children.forEach(child => {
          inner += `<div class="sn-mega-col"><a href="${child.url}" class="sn-mega-title">${child.title}</a>`;
          if (child.children && child.children.length > 0) {
            inner += `<div class="sn-mega-list">`;
            child.children.forEach(grand => { inner += `<a href="${grand.url}" class="sn-mega-sublink">${grand.title}</a>`; });
            inner += `</div>`;
          }
          inner += `</div>`;
        });
      }
      html += `<div class="sn-mega-pane" id="mega-${idx}"><div class="sn-mega-inner">${inner}</div></div>`;
    });
    return html;
  }

  getSearchQuicklinksHTML() {
    if (!this.state.currentItems) return '';
    return this.state.currentItems.map(item =>
      `<a href="${item.url}" class="sn-search-quicklink">${item.title}</a>`
    ).join('');
  }

  attachListeners() {
    this.boundHandlers.logoClick = (e) => {
      if (this.state.isOpen || this.state.cartOpen) {
        e.preventDefault();
        this.closeAll();
      }
    };
    
    this.boundHandlers.triggerClick = () => {
      if (this.state.cartOpen) { 
        this.toggleCart(); 
      } else { 
        this.toggleMenu(); 
      }
    };

    document.getElementById('sn-logo').addEventListener('click', this.boundHandlers.logoClick);
    document.getElementById('sn-trigger').addEventListener('click', this.boundHandlers.triggerClick);
    document.getElementById('sn-back-btn').addEventListener('click', this.handleBack);
    document.getElementById('sn-cart-btn').addEventListener('click', this.toggleCart);
    document.getElementById('sn-backdrop').addEventListener('click', this.closeAll);

    // Search panel. Predictive Search
    this._searchAbort = null;
    this._searchDebounce = null;
    this._searchActiveIdx = -1;
    this._searchResults = [];

    const searchBtn = document.getElementById('sn-search-btn');
    if (searchBtn) {
      searchBtn.addEventListener('click', () => this.toggleSearch());
    }
    const searchInput = document.getElementById('sn-search-input');
    const searchClear = document.getElementById('sn-search-clear');
    const searchResults = document.getElementById('sn-search-results');
    const searchQuicklinks = document.getElementById('sn-search-quicklinks');

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        const val = searchInput.value.trim();
        if (searchClear) searchClear.classList.toggle('visible', val.length > 0);
        clearTimeout(this._searchDebounce);
        if (!val || val.length < 2) {
          this._resetSearchResults();
          return;
        }
        this._searchDebounce = setTimeout(() => this._fetchPredictive(val), 220);
      });

      searchInput.addEventListener('keydown', (e) => {
        if (!searchResults || searchResults.hidden) return;
        const links = searchResults.querySelectorAll('.sn-search-result');
        if (!links.length) return;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          this._searchActiveIdx = Math.min(this._searchActiveIdx + 1, links.length - 1);
          this._highlightSearchResult(links);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          this._searchActiveIdx = Math.max(this._searchActiveIdx - 1, -1);
          this._highlightSearchResult(links);
          if (this._searchActiveIdx === -1) searchInput.focus();
        } else if (e.key === 'Enter') {
          e.preventDefault();
          if (this._searchActiveIdx >= 0) {
            links[this._searchActiveIdx].click();
          }
        }
      });

      const searchForm = document.getElementById('sn-search-form');
      if (searchForm) {
        searchForm.addEventListener('submit', (e) => e.preventDefault());
      }
    }

    if (searchClear) {
      searchClear.addEventListener('click', () => {
        searchInput.value = '';
        searchClear.classList.remove('visible');
        this._resetSearchResults();
        searchInput.focus();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.state.searchOpen) this.closeAll();
    });

    // Desktop: Auto-close cart pane when mouse leaves (Apple-style behavior)
    const cartPaneEl = document.getElementById('sn-cart-pane');
    let cartCloseTimer = null;
    if (cartPaneEl && window.matchMedia('(min-width: 1000px)').matches) {
      cartPaneEl.addEventListener('mouseleave', () => {
        if (!this.state.cartOpen) return;
        cartCloseTimer = setTimeout(() => { this.closeAll(); }, 400);
      });
      cartPaneEl.addEventListener('mouseenter', () => {
        if (cartCloseTimer) { clearTimeout(cartCloseTimer); cartCloseTimer = null; }
      });
      // Also cancel close if mouse moves back to cart button
      document.getElementById('sn-cart-btn').addEventListener('mouseenter', () => {
        if (cartCloseTimer) { clearTimeout(cartCloseTimer); cartCloseTimer = null; }
      });
    }

    const overlay = document.getElementById('sn-overlay');
    overlay.addEventListener('touchstart', this.handleTouchStart, {passive: true});
    overlay.addEventListener('touchend', this.handleTouchEnd, {passive: true});
    
    const cartPane = document.getElementById('sn-cart-pane');
    if(cartPane) {
        cartPane.addEventListener('touchstart', this.handleTouchStart, {passive: true});
        cartPane.addEventListener('touchend', this.handleTouchEnd, {passive: true});
        // X close button inside cart pane (event delegation for dynamically rendered button)
        cartPane.addEventListener('click', (e) => {
          if (e.target.closest('.sn-cart-close')) { this.closeAll(); }
        });
    }
  }

  triggerHaptic() {
    if (navigator.vibrate) navigator.vibrate(8);
  }

  startCartMonitoring() {
    if (!document.hidden) {
      this.monitorCart();
      this.cartPollInterval = setInterval(this.monitorCart, 30000); 
    }
  }

  stopCartMonitoring() {
    if (this.cartPollInterval) {
      clearInterval(this.cartPollInterval);
      this.cartPollInterval = null;
    }
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.stopCartMonitoring();
    } else {
      this.startCartMonitoring();
    }
  }

  monitorCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(c => {
        this.updateBadge(c.item_count);
        this.state.cartData = c;
        // Preload product images so they're cached when drawer opens (no delay)
        this.preloadCartImages(c);
      })
      .catch(e => {
        console.error('Cart fetch error:', e);
      });
  }

  sizedImage(url, width) {
    if (!url) return '';
    return url.includes('?') ? url + '&width=' + width : url + '?width=' + width;
  }

  preloadCartImages(cart) {
    if (!cart || !cart.items) return;
    cart.items.forEach(item => {
      if (item.image) {
        const img = new Image();
        img.src = this.sizedImage(item.image, 200);
      }
    });
  }

  preloadCart() {
    fetch('/cart.js')
      .then(r=>r.json())
      .then(c => {
        this.state.cartData = c;
      })
      .catch(e => {
        console.error('Cart preload error:', e);
      });
  }

  updateBadge(count) {
    const btn = document.getElementById('sn-cart-btn');
    if (!btn) return;
    const existing = btn.querySelector('.sn-cart-badge');
    if (existing) existing.remove();
    if (count > 0) {
      const badge = document.createElement('span');
      badge.className = 'sn-cart-badge';
      badge.innerText = count;
      btn.appendChild(badge);
    }
  }

  handleScroll() {
    if (!this.state.ticking) {
      requestAnimationFrame(this.update);
      this.state.ticking = true;
    }
  }

  update() {
    if (this.state.isOpen || this.state.cartOpen) {
      this.state.ticking = false;
      return;
    }
    
    const currentScrollY = window.scrollY;
    const header = document.querySelector('.sys-nav-bar');
    const burger = document.querySelector('.sn-global-burger');

    if (currentScrollY > 10) { 
      header?.classList.add('scrolled'); 
    } else { 
      header?.classList.remove('scrolled'); 
    }

    if (currentScrollY < 80) {
      header?.classList.remove('nav-hidden');
      burger?.classList.remove('nav-hidden');
      this.state.lastScrollY = currentScrollY;
      this.state.ticking = false;
      return;
    }

    const delta = currentScrollY - this.state.lastScrollY;
    if (delta > 8) {
      header?.classList.add('nav-hidden');
      burger?.classList.add('nav-hidden');
    } else if (delta < -8) {
      header?.classList.remove('nav-hidden');
      burger?.classList.remove('nav-hidden');
    }
    this.state.lastScrollY = currentScrollY;
    this.state.ticking = false;
  }

  // BUGFIX: Prevent layout shift
  lockScroll() {
    // Cancel any pending unlockScroll from a previous closeAll() to prevent race condition
    if (this._unlockTimer) { clearTimeout(this._unlockTimer); this._unlockTimer = null; }
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    document.body.style.overflow = 'hidden';
    
    const header = document.querySelector('.sys-nav-bar');
    if(header) header.style.paddingRight = `${scrollbarWidth}px`;
    
    const burger = document.querySelector('.sn-global-burger');
    if(burger) burger.style.right = `${scrollbarWidth}px`;
  }

  unlockScroll() {
    document.body.style.paddingRight = '';
    document.body.style.overflow = '';

    const header = document.querySelector('.sys-nav-bar');
    if(header) header.style.paddingRight = '';

    const burger = document.querySelector('.sn-global-burger');
    if(burger) burger.style.right = '';
  }

  renderCartHTML(cart) {
    let sidebarHtml = '';
    
    sidebarHtml += `<a href="/cart" class="sn-cart-cta">Einkaufstasche ansehen</a>`;
    
    const validIcons = this.quickLinks.filter(l => l.title && l.title.trim() !== "");
    
    if (validIcons.length > 0) {
      sidebarHtml += '<div class="sn-quick-links">';
      validIcons.forEach(link => {
        const icons = {
          box: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>',
          heart: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>',
          user: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>',
          bookmark: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path></svg>',
          circle: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>'
        };
        const iconSvg = icons[link.icon] || icons.circle;
        sidebarHtml += `<a href="${link.url}" class="sn-quick-link">${iconSvg}<span>${link.title}</span></a>`;
      });
      sidebarHtml += '</div>';
    }

    if (this.cartMenu.length > 0) {
      sidebarHtml += `<span class="sn-menu-title">${this.menuSettings.title}</span>`;
      sidebarHtml += '<div class="sn-quick-links">';

      this.cartMenu.forEach(item => {
        let finalUrl = item.url;
        let finalText = item.title;
        const isLoggedIn = this.isCustomer;

        if (item.function === 'orders') {
          finalUrl = isLoggedIn ? this.routes.orders : this.routes.login;
        } 
        else if (item.function === 'account') {
          finalUrl = isLoggedIn ? this.routes.account : this.routes.login;
        }
        else if (item.function === 'login_logout') {
          if (isLoggedIn) {
             finalUrl = this.routes.logout;
             if(item.titleLoggedIn) finalText = item.titleLoggedIn;
             else finalText = "Abmelden";
          } else {
             finalUrl = this.routes.login;
          }
        }
        
        let iconSvg = '';
        if (item.function === 'orders') iconSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>';
        else if (item.function === 'account') iconSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>';
        else if (item.function === 'login_logout') {
            if (isLoggedIn) iconSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>'; 
            else iconSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>'; 
        } else {
             iconSvg = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>';
        }

        sidebarHtml += `<a href="${finalUrl}" class="sn-quick-link">${iconSvg}<span>${finalText}</span></a>`;
      });
      sidebarHtml += '</div>';
    }

    const closeBtn = '<button class="sn-cart-close" aria-label="Schlie\u00dfen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>';

    if (!cart || cart.item_count === 0) {
      // Empty cart: same layout structure as full cart (left-aligned, Mein Profil at bottom)
      return `<div class="sn-cart-layout">${closeBtn}<div class="sn-cart-top"><p class="sn-cart-empty-title">Deine Einkaufstasche wartet noch.</p><p class="sn-cart-empty-text">Vielleicht ist das richtige Teil f\u00fcr deinen Hund nur <a href="/" class="sn-cart-inline-link">einen Klick entfernt</a>.</p></div><div class="sn-cart-bottom">${sidebarHtml.replace('<a href="/cart" class="sn-cart-cta">Einkaufstasche ansehen</a>', '')}</div></div>`;
    }

    let itemsHtml = '';
    var sortedItems = cart.items.slice().sort(function(a, b) {
      var aUp = !!(a.properties && (a.properties['_upsell'] === '1' || a.properties._upsell === '1'));
      var bUp = !!(b.properties && (b.properties['_upsell'] === '1' || b.properties._upsell === '1'));
      if (aUp && !bUp) return 1;
      if (!aUp && bUp) return -1;
      return 0;
    });
    sortedItems.forEach(item => {
      itemsHtml += `
        <div class="sn-cart-item-row">
           <div class="sn-cart-img-wrap"><img src="${this.sizedImage(item.image, 200)}" class="sn-cart-img" alt="${item.product_title}" loading="eager"></div>
           <div class="sn-cart-details"><span class="sn-cart-name">${item.product_title}</span></div>
        </div>`;
    });

    return `<div class="sn-cart-layout">${closeBtn}<div class="sn-cart-top"><div class="sn-cart-header-row"><div class="sn-cart-header">Einkaufstasche</div><a href="/cart" class="sn-cart-cta">Einkaufstasche ansehen</a></div><div class="sn-cart-list">${itemsHtml}</div></div><div class="sn-cart-bottom">${sidebarHtml.replace('<a href="/cart" class="sn-cart-cta">Einkaufstasche ansehen</a>', '')}</div></div>`;
  }

  toggleCart() {
    this.triggerHaptic();
    
    // NEW: Check if Drawer is enabled
    if (!this.enableCartDrawer) {
      window.location.href = '/cart';
      return;
    }

    const pane = document.getElementById('sn-cart-pane');
    const backdrop = document.getElementById('sn-backdrop');
    const area = document.getElementById('sn-cart-content-area');
    
    if (this.state.cartOpen) {
      this.closeAll();
    } else {
      if(this.state.isOpen) this.toggleMenu();
      this.state.cartOpen = true;

      // 1. Render content FIRST (before animation to prevent reflow jitter)
      if (this.state.cartData) {
        area.innerHTML = this.renderCartHTML(this.state.cartData);
        document.dispatchEvent(new CustomEvent('cart:rendered'));
      } else {
        area.innerHTML = '<div style="opacity:0.5; padding:40px; text-align:center;">Laden...</div>';
      }

      // 2. Force header visible (scroll-hide may have hidden it)
      document.querySelector('.sys-nav-bar')?.classList.remove('nav-hidden');
      document.querySelector('.sn-global-burger')?.classList.remove('nav-hidden');

      // 3. THEN start animation, immediate class toggle (like menu, no rAF delay)
      this.host.classList.add('is-open-cart');
      document.body.classList.add('sn-cart-open');
      this.lockScroll();
      pane.classList.add('active');
      backdrop.classList.add('active');

      // 3. Fetch fresh data AFTER animation finishes (800ms > 700ms animation)
      // AbortController cancels if user closes cart before fetch completes
      if (this._cartFetchCtrl) this._cartFetchCtrl.abort();
      this._cartFetchCtrl = new AbortController();
      const signal = this._cartFetchCtrl.signal;
      setTimeout(() => {
        if (signal.aborted) return;
        fetch('/cart.js', { signal })
          .then(r=>r.json())
          .then(c => {
            // Compare cart DATA, not innerHTML (innerHTML includes injected upsell → always differs)
            const old = this.state.cartData;
            const changed = !old || old.item_count !== c.item_count || old.total_price !== c.total_price;
            this.state.cartData = c;
            if (changed) {
              area.innerHTML = this.renderCartHTML(c);
              document.dispatchEvent(new CustomEvent('cart:rendered'));
            }
          })
          .catch(e => {
            if (e.name !== 'AbortError') console.error('Cart load error:', e);
          });
      }, 800);
    }
  }

  toggleSearch() {
    this.triggerHaptic();
    const searchPane = document.getElementById('sn-search-pane');
    const searchInput = document.getElementById('sn-search-input');
    const backdrop = document.getElementById('sn-backdrop');

    if (this.state.searchOpen) {
      this.closeAll();
      return;
    }

    // Close other panels first
    if (this.state.cartOpen) this.toggleCart();
    if (this.state.isOpen) this.toggleMenu();

    this.state.searchOpen = true;
    if (searchPane) searchPane.classList.add('active');
    if (backdrop) backdrop.classList.add('active');
    setTimeout(() => { if (searchInput) searchInput.focus(); }, 100);
  }

  closeAll() {
    // Cancel any pending cart fetches to prevent DOM updates during close
    if (this._cartFetchCtrl) { this._cartFetchCtrl.abort(); this._cartFetchCtrl = null; }
    if (this._eventFetchCtrl) { this._eventFetchCtrl.abort(); this._eventFetchCtrl = null; }
    // Close mega nav immediately
    this._megaCloseImmediate();
    const pane = document.getElementById('sn-cart-pane');
    const backdrop = document.getElementById('sn-backdrop');
    const overlay = document.getElementById('sn-overlay');
    const searchPane = document.getElementById('sn-search-pane');
    if(pane) pane.classList.remove('active');
    if(backdrop) backdrop.classList.remove('active');
    if(overlay) overlay.classList.remove('active');
    if(searchPane) searchPane.classList.remove('active');
    this.host.classList.remove('is-open-cart');
    this.host.classList.remove('is-open');
    document.body.classList.remove('sn-cart-open');
    document.body.classList.remove('sn-menu-open');
    // Delay unlockScroll until close animation finishes (0.7s animation → 750ms delay)
    // Store timer so lockScroll() can cancel it if cart reopens before unlock fires
    this._unlockTimer = setTimeout(() => { this.unlockScroll(); this._unlockTimer = null; }, 750);
    this.state.cartOpen = false;
    this.state.isOpen = false;
    this.state.searchOpen = false;
    if (this._searchAbort) { this._searchAbort.abort(); this._searchAbort = null; }
    clearTimeout(this._searchDebounce);
    this._searchActiveIdx = -1;
  }

  /* =============================================
     PREDICTIVE SEARCH. Shopify Suggest API
     ============================================= */

  _resetSearchResults() {
    const results = document.getElementById('sn-search-results');
    const quicklinks = document.getElementById('sn-search-quicklinks');
    if (results) { results.hidden = true; while (results.firstChild) results.removeChild(results.firstChild); }
    if (quicklinks) quicklinks.hidden = false;
    this._searchActiveIdx = -1;
    if (this._searchAbort) { this._searchAbort.abort(); this._searchAbort = null; }
  }

  _fetchPredictive(query) {
    if (this._searchAbort) this._searchAbort.abort();
    this._searchAbort = new AbortController();
    const signal = this._searchAbort.signal;

    const quicklinks = document.getElementById('sn-search-quicklinks');
    const results = document.getElementById('sn-search-results');
    if (!results) return;

    if (quicklinks) quicklinks.hidden = true;
    results.hidden = false;
    while (results.firstChild) results.removeChild(results.firstChild);
    const loadDiv = document.createElement('div');
    loadDiv.className = 'sn-search-loading';
    const loadSpan = document.createElement('span');
    loadSpan.textContent = 'Suche\u2026';
    loadDiv.appendChild(loadSpan);
    results.appendChild(loadDiv);

    const url = '/search/suggest.json?q=' + encodeURIComponent(query)
      + '&resources[type]=query,product,article,collection,page'
      + '&resources[limit]=4'
      + '&resources[limit_scope]=each'
      + '&resources[options][unavailable_products]=hide';

    fetch(url, { signal })
      .then(r => r.json())
      .then(data => {
        if (signal.aborted) return;
        this._renderPredictive(data, query, results, quicklinks);
      })
      .catch(e => {
        if (e.name === 'AbortError') return;
        while (results.firstChild) results.removeChild(results.firstChild);
        results.hidden = true;
        if (quicklinks) quicklinks.hidden = false;
      });
  }

  _renderPredictive(data, query, results, quicklinks) {
    while (results.firstChild) results.removeChild(results.firstChild);

    const r = data.resources && data.resources.results;
    if (!r) { this._resetSearchResults(); return; }

    const queries = r.queries || [];
    const products = r.products || [];
    const articles = r.articles || [];
    const collections = r.collections || [];
    const pages = r.pages || [];
    const total = queries.length + products.length + articles.length + collections.length + pages.length;

    if (total === 0) {
      if (quicklinks) quicklinks.hidden = true;
      results.hidden = false;
      const noRes = document.createElement('div');
      noRes.className = 'sn-search-no-results';
      const strong = document.createElement('strong');
      strong.textContent = '\u201e' + query + '\u201c';
      noRes.appendChild(document.createTextNode('Keine Ergebnisse f\u00fcr '));
      noRes.appendChild(strong);
      noRes.appendChild(document.createElement('br'));
      noRes.appendChild(document.createTextNode('Pr\u00fcfe die Schreibweise oder verwende andere Begriffe.'));
      results.appendChild(noRes);
      this._searchActiveIdx = -1;
      return;
    }

    const mkSvg = (svgStr) => {
      const t = document.createElement('template');
      t.innerHTML = svgStr.trim();
      return t.content.firstChild;
    };
    const searchSvg = '<svg class="sn-search-result__icon" width="16" height="16" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"><circle cx="8" cy="8" r="6"></circle><line x1="12.5" y1="12.5" x2="16" y2="16"></line></svg>';
    const articleSvg = '<svg class="sn-search-result__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>';
    const collSvg = '<svg class="sn-search-result__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>';
    const pageSvg = '<svg class="sn-search-result__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>';

    const buildGroup = (title, items, renderer) => {
      if (!items.length) return;
      const group = document.createElement('div');
      group.className = 'sn-search-group';
      const h = document.createElement('div');
      h.className = 'sn-search-group__title';
      h.textContent = title;
      group.appendChild(h);
      const ul = document.createElement('ul');
      ul.className = 'sn-search-group__list';
      items.forEach(item => { const li = document.createElement('li'); li.appendChild(renderer(item)); ul.appendChild(li); });
      group.appendChild(ul);
      results.appendChild(group);
    };

    buildGroup('Vorschl\u00e4ge', queries, (q) => {
      const a = document.createElement('a');
      a.href = '/search?q=' + encodeURIComponent(q.text || query);
      a.className = 'sn-search-result';
      a.appendChild(mkSvg(searchSvg));
      const span = document.createElement('span');
      span.className = 'sn-search-result__title';
      if (q.styled_text) {
        const t = document.createElement('template'); t.innerHTML = q.styled_text; span.appendChild(t.content);
      } else {
        this._setHighlight(span, q.text || '', query);
      }
      a.appendChild(span);
      return a;
    });

    buildGroup('Produkte', products, (p) => {
      const a = document.createElement('a');
      a.href = p.url;
      a.className = 'sn-search-result';
      if (p.image) {
        const img = document.createElement('img');
        img.src = this._thumbUrl(p.image, 80);
        img.alt = '';
        img.className = 'sn-search-result__img';
        img.loading = 'lazy';
        a.appendChild(img);
      } else {
        const ph = document.createElement('div');
        ph.className = 'sn-search-result__img';
        a.appendChild(ph);
      }
      const info = document.createElement('div');
      info.className = 'sn-search-result__info';
      const title = document.createElement('span');
      title.className = 'sn-search-result__title';
      this._setHighlight(title, p.title, query);
      info.appendChild(title);
      const parts = [];
      if (p.vendor) parts.push(p.vendor);
      if (p.price) parts.push(this._fmtPrice(p.price));
      if (parts.length) {
        const meta = document.createElement('span');
        meta.className = 'sn-search-result__meta';
        meta.textContent = parts.join(' \u00b7 ');
        info.appendChild(meta);
      }
      a.appendChild(info);
      return a;
    });

    buildGroup('Ratgeber', articles, (ar) => {
      const a = document.createElement('a');
      a.href = ar.url;
      a.className = 'sn-search-result';
      if (ar.image) {
        const img = document.createElement('img');
        img.src = this._thumbUrl(ar.image, 80);
        img.alt = '';
        img.className = 'sn-search-result__img';
        img.loading = 'lazy';
        a.appendChild(img);
      } else {
        a.appendChild(mkSvg(articleSvg));
      }
      const info = document.createElement('div');
      info.className = 'sn-search-result__info';
      const title = document.createElement('span');
      title.className = 'sn-search-result__title';
      this._setHighlight(title, ar.title, query);
      info.appendChild(title);
      a.appendChild(info);
      return a;
    });

    buildGroup('Kollektionen', collections, (c) => {
      const a = document.createElement('a');
      a.href = c.url;
      a.className = 'sn-search-result';
      a.appendChild(mkSvg(collSvg));
      const span = document.createElement('span');
      span.className = 'sn-search-result__title';
      this._setHighlight(span, c.title, query);
      a.appendChild(span);
      return a;
    });

    buildGroup('Seiten', pages, (pg) => {
      const a = document.createElement('a');
      a.href = pg.url;
      a.className = 'sn-search-result';
      a.appendChild(mkSvg(pageSvg));
      const span = document.createElement('span');
      span.className = 'sn-search-result__title';
      this._setHighlight(span, pg.title, query);
      a.appendChild(span);
      return a;
    });



    if (quicklinks) quicklinks.hidden = true;
    results.hidden = false;
    this._searchActiveIdx = -1;
  }

  _setHighlight(el, text, query) {
    if (!query || !text) { el.textContent = text || ''; return; }
    const lower = text.toLowerCase();
    const qLower = query.toLowerCase();
    const idx = lower.indexOf(qLower);
    if (idx === -1) { el.textContent = text; return; }
    el.appendChild(document.createTextNode(text.slice(0, idx)));
    const mark = document.createElement('mark');
    mark.textContent = text.slice(idx, idx + query.length);
    el.appendChild(mark);
    el.appendChild(document.createTextNode(text.slice(idx + query.length)));
  }

  _thumbUrl(url, size) {
    if (!url) return '';
    if (url.includes('_' + size + 'x')) return url;
    return url.replace(/(\.[^.]+)$/, '_' + size + 'x$1');
  }

  _fmtPrice(cents) {
    if (typeof cents === 'string' && cents.includes('.')) cents = Math.round(parseFloat(cents) * 100);
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    if (!cents && cents !== 0) return '';
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  _highlightSearchResult(links) {
    links.forEach((l, i) => l.classList.toggle('is-active', i === this._searchActiveIdx));
    if (this._searchActiveIdx >= 0 && links[this._searchActiveIdx]) {
      links[this._searchActiveIdx].scrollIntoView({ block: 'nearest' });
    }
  }

  handleTouchStart(e) {
    this.state.touchStartX = e.changedTouches[0].screenX;
    this.state.touchStartY = e.changedTouches[0].screenY;
  }

  handleTouchEnd(e) {
    if ((e.changedTouches[0].screenX - this.state.touchStartX) > 60 &&
    Math.abs(e.changedTouches[0].screenY - this.state.touchStartY) < 40) {
      if (this.state.history.length > 0) this.handleBack();
    }
  }

  /* =============================================
     APPLE-STYLE MEGA NAV — Hover Intent + Crossfade + Height Animation
     ============================================= */

  initDesktopHover() {
    this._shell = document.getElementById('sn-mega-shell');
    this._backdrop = document.querySelector('.sn-desktop-backdrop');
    this._megaItems = Array.from(document.querySelectorAll('.has-mega'));
    this._activePane = null;
    this._activeItem = null;
    this._megaLeaveTimer = null;
    this._megaCloseTimer = null;

    // Nav item hover events
    this._megaItems.forEach(el => {
      const link = el.querySelector('.sn-desktop-link');
      if (link) link.addEventListener('click', e => e.preventDefault());
      el.addEventListener('mouseenter', () => this._megaEnter(el));
      el.addEventListener('mouseleave', () => this._megaScheduleLeave());
    });

    // Shell hover keeps menu open (cursor moved from link into the dropdown)
    if (this._shell) {
      this._shell.addEventListener('mouseenter', () => {
        clearTimeout(this._megaLeaveTimer);
        clearTimeout(this._megaCloseTimer);
      });
      this._shell.addEventListener('mouseleave', () => this._megaScheduleLeave());
    }
  }

  _megaEnter(itemEl) {
    clearTimeout(this._megaLeaveTimer);
    clearTimeout(this._megaCloseTimer);

    if (this.state.cartOpen || this.state.searchOpen) this.closeAll();

    const paneId = itemEl.dataset.mega;
    const pane = document.getElementById(paneId);
    if (!pane || !this._shell) return;

    const isSwitching = this._activePane && this._activePane !== pane;

    // Deactivate previous pane (crossfade out)
    if (this._activePane && this._activePane !== pane) {
      this._activePane.classList.remove('is-active');
      this._activePane.querySelectorAll('.sn-mega-col').forEach(c => c.classList.remove('is-visible'));
      this._activeItem?.querySelector('.sn-desktop-link')?.classList.remove('is-mega-active');
    }

    // Activate new pane
    this._activePane = pane;
    this._activeItem = itemEl;
    pane.classList.add('is-active');
    itemEl.querySelector('.sn-desktop-link')?.classList.add('is-mega-active');

    // Measure pane height and animate shell
    const h = pane.offsetHeight;
    this._shell.style.height = h + 'px';
    this._shell.classList.add('is-open');
    this._shell.classList.remove('is-closing');

    // Show backdrop
    this._backdrop?.classList.add('active');

    // Stagger column animations (faster when switching between items)
    const cols = pane.querySelectorAll('.sn-mega-col');
    const baseDelay = isSwitching ? 40 : 80;
    cols.forEach((col, i) => {
      setTimeout(() => col.classList.add('is-visible'), baseDelay + i * 20);
    });
  }

  _megaScheduleLeave() {
    clearTimeout(this._megaLeaveTimer);
    this._megaLeaveTimer = setTimeout(() => this._megaClose(), 120);
  }

  _megaClose() {
    if (!this._activePane || !this._shell) return;

    // Phase 1: Fade out columns
    this._activePane.querySelectorAll('.sn-mega-col').forEach(c => c.classList.remove('is-visible'));
    this._activeItem?.querySelector('.sn-desktop-link')?.classList.remove('is-mega-active');
    this._shell.classList.add('is-closing');

    // Phase 2: After columns fade, collapse shell height
    this._megaCloseTimer = setTimeout(() => {
      if (this._activePane) this._activePane.classList.remove('is-active');
      this._shell.style.height = '0';
      this._shell.classList.remove('is-open');
      this._shell.classList.remove('is-closing');
      this._backdrop?.classList.remove('active');
      this._activePane = null;
      this._activeItem = null;
    }, 150);
  }

  _megaCloseImmediate() {
    clearTimeout(this._megaLeaveTimer);
    clearTimeout(this._megaCloseTimer);
    if (!this._shell) return;
    if (this._activePane) {
      this._activePane.classList.remove('is-active');
      this._activePane.querySelectorAll('.sn-mega-col').forEach(c => c.classList.remove('is-visible'));
    }
    if (this._activeItem) {
      this._activeItem.querySelector('.sn-desktop-link')?.classList.remove('is-mega-active');
    }
    this._shell.style.height = '0';
    this._shell.classList.remove('is-open');
    this._shell.classList.remove('is-closing');
    this._activePane = null;
    this._activeItem = null;
  }

  toggleMenu() {
    this.triggerHaptic();
    const isOpening = !this.host.classList.contains('is-open');
    if (isOpening) {
      this.closeAll();
      this.host.classList.add('is-open');
      document.body.classList.add('sn-menu-open');
      this.lockScroll(); // FIX: Lock scroll
      this.state.isOpen = true;
      this.state.history = [];
      document.querySelector('.sys-nav-bar')?.classList.remove('nav-hidden');
      document.querySelector('.sn-global-burger')?.classList.remove('nav-hidden');
      this.renderList(window.SysNavData.root, 'reset');
    } else {
      this.closeAll();
    }
  }

  renderList(items, mode = 'next') {
    const wrapper = document.getElementById('sn-list-wrapper');
    const backBtn = document.getElementById('sn-back-btn');
    if (mode !== 'reset') {
      wrapper.style.opacity = '0';
      wrapper.style.transition = 'opacity 0.15s ease-out';
    }
    
    setTimeout(() => {
      let html = '';
      let animClass = 'anim-vertical'; 
      if (mode === 'next') animClass = 'anim-next';
      if (mode === 'back') animClass = 'anim-back';
      
      items.forEach((item, index) => {
        const hasKids = item.hasChildren;
        html += `<div class="sn-item ${animClass}" style="--i: ${index}"><div class="sn-link-wrap" data-id="${item.id}" data-url="${item.url}"><span class="sn-link-text">${item.title}</span>${hasKids ? '<span class="sn-chevron-small">›</span>' : ''}</div></div>`;
      });
      
      wrapper.innerHTML = html;
      wrapper.querySelectorAll('.sn-link-wrap').forEach(row => {
        row.addEventListener('click', (e) => {
          e.preventDefault();
          const item = items.find(i => i.id === row.getAttribute('data-id'));
          if (item) { 
            if (item.hasChildren) {
              this.handleDrillDown(item);
            } else {
              window.location.href = item.url;
            } 
          }
        });
      });
      
      if (this.state.history.length > 0) backBtn.classList.remove('hidden'); 
      else backBtn.classList.add('hidden');
      
      wrapper.style.opacity = '1'; 
      wrapper.style.transition = '';
      
      if (mode === 'back') document.querySelector('.sn-viewport').scrollTop = 0;
    }, mode === 'reset' ? 0 : 150);
  }

  handleDrillDown(parent) {
    this.triggerHaptic();
    const viewport = document.querySelector('.sn-viewport');
    this.state.history.push({
      items: this.state.currentItems,
      scroll: viewport ? viewport.scrollTop : 0
    });
    this.state.currentItems = parent.children;
    this.renderList(this.state.currentItems, 'next');
    if(viewport) viewport.scrollTop = 0;
  }

  handleBack() {
    this.triggerHaptic();
    if (this.state.history.length === 0) return;
    const prevState = this.state.history.pop();
    this.state.currentItems = prevState.items;
    this.renderList(prevState.items, 'back');
  }

  destroy() {
    window.removeEventListener('scroll', this.handleScroll);
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.stopCartMonitoring();
    
    if (this.boundHandlers.logoClick) {
      const logo = document.getElementById('sn-logo');
      if (logo) logo.removeEventListener('click', this.boundHandlers.logoClick);
    }
    if (this.boundHandlers.triggerClick) {
      const trigger = document.getElementById('sn-trigger');
      if (trigger) trigger.removeEventListener('click', this.boundHandlers.triggerClick);
    }

    this.boundHandlers = {};
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new AppleNav().init());
} else {
  new AppleNav().init();
}

document.addEventListener('shopify:section:load', function(event) {
  if(event.detail.sectionId.includes('custom-apple-header')) {
    new AppleNav().init();
  }
});
